import SentenceFieldSimple from '@pretto/bricks/components/form/SentenceFieldSimple'
import BaseTypo from '@pretto/bricks/components/typography/BaseTypo'
import Row from '@pretto/bricks/shared/components/Row'

import PropTypes from 'prop-types'
import { memo } from 'react'

import * as S from './styles'

const InputSlider = ({ label, sliderProps, sentenceFieldSimpleProps, ...props }) => (
  <div {...props}>
    <Row
      label={<BaseTypo typo="headline16">{label}</BaseTypo>}
      value={<SentenceFieldSimple {...sentenceFieldSimpleProps} />}
    />

    <S.Slider {...sliderProps} />
  </div>
)

InputSlider.propTypes = {
  /** Text above slider. */
  label: PropTypes.string.isRequired,
  /** Props of [`SentenceFieldSimple`](/#!/SentenceFieldSimple) component. */
  sentenceFieldSimpleProps: PropTypes.object.isRequired,
  /** Props of [`Slider`](/#!/Slider) component. */
  sliderProps: PropTypes.object.isRequired,
}

export default memo(InputSlider)
